import cn from 'classnames';
// Constants
import { SCHEDULE_STREAM } from 'constants/routes';
// Hooks
import { useGetCurrUser, useOnboardingContext, useAppContext } from 'hooks';
// Helpers
import { isUserCustomer, isStoreRole } from 'helpers/user';
// Styles
import styles from './EyebrowNav.module.scss';

type EyebrowNavProps = {
  className?: string;
  fixed?: boolean;
};

export const EyebrowNav = ({ className, fixed }: EyebrowNavProps) => {
  const { data: currentUser } = useGetCurrUser();

  const {
    setShowOnboardingModal,
    setShowCreateStreamModal,
  } = useOnboardingContext();
  const { setSignUpModalVisibility, setSignUpStep } = useAppContext();

  const isLoggedIn = Boolean(currentUser?.me?.id);
  const isCustomer = isUserCustomer(currentUser);
  const isCreator = isStoreRole(currentUser?.me?.role);

  const handleHostPPVClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    if (isLoggedIn) {
      if (isCustomer) {
        setShowOnboardingModal(true);
      } else if (isCreator) {
        setShowCreateStreamModal(true);
      }
    } else {
      setSignUpStep(0);
      setSignUpModalVisibility(true);
    }
  };

  return (
    <div className={cn(styles.root, className, { [styles.fixed]: fixed })}>
      <div className={styles.rightPart}>
        <a
          href={isCreator ? SCHEDULE_STREAM : '#'}
          className={styles.link}
          onClick={handleHostPPVClick}
        >
          HOST A PPV
        </a>
        <div className={styles.separator} />
        <a
          href="https://advertising.millions.co/"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}
        >
          ADVERTISE WITH MILLIONS
        </a>
      </div>
    </div>
  );
};

export default EyebrowNav;
